import { supabase } from "../supabaseClient";

const parsePayload = async (data, error) => {
  if (data && typeof data === "object") return data;
  if (!error?.context?.json) return null;
  try {
    return await error.context.json();
  } catch (_) {
    return null;
  }
};

const invokeSignupPayments = async (body) => {
  const { data, error } = await supabase.functions.invoke("signup-payments", {
    body,
  });
  const payload = await parsePayload(data, error);
  if (error) {
    throw new Error(
      payload?.error || error.message || "Could not process this payment."
    );
  }
  if (payload?.error) {
    throw new Error(payload.error);
  }
  return payload;
};

export const getPayNowStatus = (tournamentId) =>
  invokeSignupPayments({ action: "status", tournamentId });

const browserTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch (_) {
    return "";
  }
};

export const createSignupCheckout = ({ tournamentId, signupIds }) =>
  invokeSignupPayments({
    action: "checkout",
    tournamentId,
    signupIds,
    returnOrigin: window.location.origin,
    timeZone: browserTimeZone(),
  });

export const confirmSignupCheckout = ({ tournamentId, sessionId }) =>
  invokeSignupPayments({
    action: "confirm",
    tournamentId,
    sessionId,
  });

export const refundSignupPayment = ({ signupId, stay }) =>
  invokeSignupPayments({ action: "refund", signupId, stay });

export const requestSignupRefund = ({ signupId, reason }) =>
  invokeSignupPayments({ action: "request_refund", signupId, reason });

export const cancelSignupWithRefund = ({ signupId }) =>
  invokeSignupPayments({ action: "cancel", signupId });
